module.exports = __webpack_public_path__ + "static/media/Text.08075b49.svg";